export class ServerSelectionNotMatchingVersionError extends Error {
    public constructor() {
        super('Server version is not matching');

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ServerSelectionNotMatchingVersionError.prototype);
    }
}

export class ServerSelectionNoApiError extends Error {
    public constructor() {
        super('Api not found');

        // Set the prototype explicitly.
        // @see https://github.com/microsoft/TypeScript-wiki/blob/81fe7b91664de43c02ea209492ec1cea7f3661d0/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ServerSelectionNoApiError.prototype);
    }
}
